import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ComponentsModule } from '@mastechnicaegroup/carelinelive-ui';
import { Commissioner } from '@lib/api/models/commissioner';

@Component({
    selector: 'app-commissioner-working-hours',
    imports: [
        ComponentsModule,
        DatePipe
    ],
    templateUrl: './commissioner-working-hours.component.html',
    standalone: true,
    styleUrl: './commissioner-working-hours.component.scss'
})
export class CommissionerWorkingHoursComponent implements OnInit {

    @Input() commissionerData: Commissioner | undefined;
    @Output() editWorkingHoursEvent: EventEmitter<void> = new EventEmitter<void>();

    fullWeekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    completeWeekdays: { id: string, weekday: string, start_time: string, end_time: string, open: boolean }[] = [];

    ngOnInit() {
        const commissionerByDay = new Map(
            this.commissionerData?.working_hours.map(item => [item.weekday, item])
        );

        this.completeWeekdays = this.fullWeekdays.map(day => {
            return commissionerByDay.get(day) || { id: day, weekday: day, start_time: '', end_time: '', open: false };
        });
    }

    editWorkingHours() {
        window.scrollTo(0, 0);
        this.editWorkingHoursEvent.emit();
    }
}
